<app-layout>
    <mat-toolbar class="page-header" role="heading">
        <h1>{{ 'ReviewStatusReport' | translate: {Default: "Review Status Report"} }}</h1>
    </mat-toolbar>

    <div class="content">
        <app-review-status-details-data-grid></app-review-status-details-data-grid>
    </div>
</app-layout>
